import styled from 'styled-components';
import Input from '../input/Input';
export const CustomInput = styled(Input) `
  .input-placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
//# sourceMappingURL=styles.js.map